<template>
	<el-dialog
		:visible.sync="visible"
		:width="width"
		:title="title"
	>

		<span>{{ msg }}</span>

		<span slot="footer" class="dialog-footer">

			<el-button @click="cancelClick">{{ cancelText }}</el-button>

			<el-button type="primary" @click="acceptClick">{{ acceptText }}</el-button>

		</span>

	</el-dialog>
</template>

<script>
	export default {
		name: 'ChatDialog',
		data () {
			return {
				visible: false,
				accept: () => {},
				cancel: () => {},
				msg: '',
				title: '',
				cancelText: 'Cancelar',
				acceptText: 'Aceptar',
				width: '30%'
			}
		},
		methods: {

			open (options) {

				Object.assign(this.$data, {
					...{
						visible: false,
						accept: () => {},
						cancel: () => {},
						msg: '',
						title: '',
						cancelText: 'Cancelar',
						acceptText: 'Aceptar',
						width: '30%'
					},
					...options
				})

				this.visible = true

			},

			acceptClick () {

				this.accept()

				this.visible = false

			},

			cancelClick () {

				this.cancel()

				this.visible = false

			}

		}
	}
</script>
